import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import EditFieldDrawer from './lead_form_fields/Edit';

const LeadFormFields = ({ website_quoter, loadWebsiteQuoter }) => {
  const [field, setField] = useState(null);

  const handleSave = () => {
    loadWebsiteQuoter();
    setField(null);
  };

  return (
    <>
      <EditFieldDrawer
        field={field}
        onClose={setField.bind(null, null)}
        onSave={handleSave}
        show={!!field}
      />

      <Table
        columns={[
          {
            id: 'label',
            is_sortable: true,
            label: 'Label'
          },
          {
            id: 'is_visible',
            label: 'visible',
            render: field =>
              field.is_visible ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              ) : null,
            styles: { textAlign: 'center' }
          },
          {
            id: 'is_visible_on_config',
            label: 'visible w/ config',
            render: field =>
              field.is_visible_on_config ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              ) : null,
            styles: { textAlign: 'center' }
          },
          {
            id: 'is_required',
            label: 'required',
            render: field =>
              field.is_required ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              ) : null,
            styles: { textAlign: 'center' }
          }
        ]}
        data={website_quoter.fields}
        onRowClick={setField}
      />
    </>
  );
};

LeadFormFields.propTypes = {
  loadWebsiteQuoter: PropTypes.func,
  website_quoter: PropTypes.object
};

export default LeadFormFields;
